export default {
  path: 'winter-service/v2/requests',
  name: 'WinterService2Requests',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/RequestsIndex.vue')
}
